import { handlePdfDownload } from 'components/CommonUtilityServices/DownloadPdfService';
import { ELECTRONIC_COMMISSION_AGENCY_SWEEP_LINK, QUALTRICS_SURVEY_LINK } from 'constants/static';
import React, { useState } from 'react';
import { Alert, Box, Card, Col, Link, Typography } from '../../AORedesign';

const FormsAndRequests = () => {
  const [isDownloadingPdfErrorVisible, setIsDownloadingPdfErrorVisible] = useState(false);
  const [downloadingPdfError, setDownloadingPdfError] = useState('');

  const handleClickDownloadPdf = (event) => {
    setIsDownloadingPdfErrorVisible(false);
    const pdfUrl = event.currentTarget.getAttribute('data-pdf');

    handlePdfDownload('GET', null, pdfUrl, () => {}, setDownloadingPdfError, setIsDownloadingPdfErrorVisible, 'newWindow');
  };

  const resetErrorVisibility = () => {
    setIsDownloadingPdfErrorVisible(false);
  };

  return (
    <Col xs={6}>
      <Card style={{ height: '100%' }}>
        <Box mb={2}>
          <Box mt={1} mb={4}>
            <Typography variant="h6">Forms & Requests</Typography>
          </Box>
          {isDownloadingPdfErrorVisible && <Alert color="error" alertTitleMessage={downloadingPdfError} />}
          <Box mt={2} mb={4}>
            <Box>
              <Typography variant="button" display="block" gutterBottom>
                FORMS
              </Typography>
            </Box>
            <Box mt={1}>
              <Typography>
                <Link data-pdf="/resources/Policyholder EFT Authorization Form.pdf" onClick={handleClickDownloadPdf} endIcon="pdf">
                  Customer EFT Enrollment
                </Link>
              </Typography>
            </Box>
            <Box mt={1}>
              <Typography>
                <Link data-pdf="/resources/Statement_Of_No_Loss.pdf" onClick={handleClickDownloadPdf} endIcon="pdf">
                  Statement of No Loss
                </Link>
              </Typography>
            </Box>
            <Box mt={1}>
              <Typography>
                <Link href={ELECTRONIC_COMMISSION_AGENCY_SWEEP_LINK} endIcon="openInNew">
                  Electronic Commission & Agency Sweep Authorization
                </Link>
              </Typography>
            </Box>
          </Box>
          <Box mt={2}>
            <Typography variant="button" display="block" gutterBottom>
              REQUESTS
            </Typography>{' '}
          </Box>
          <Box mt={1}>
            <Typography>
              <Link href={'https://brandfolder.com/s/38xk5873nvp8ntcwhw256hxv'} endIcon="openInNew">
                Change of Agency Information Request
              </Link>
            </Typography>
          </Box>
          <Box mt={1}>
            <Typography>
              <Link onClick={resetErrorVisibility} href={QUALTRICS_SURVEY_LINK} endIcon="openInNew">
                Download/Retransmit
              </Link>
            </Typography>
          </Box>
        </Box>
      </Card>
    </Col>
  );
};

export default FormsAndRequests;
